import adminDataLocal from '../data/admin-data.json';

/** Fetch the generated admin data.json and extract content + products. */
export async function loadContentData() {
  const data = adminDataLocal;

  const content = data.content || {};
  const products = data.products || [];

  // Build product pricing lookup
  const productPricing = {};
  products.forEach((p) => {
    productPricing[p.id] = p.pricing?.EUR || null;
  });

  // Build club map
  const clubMap = {};
  (content.clubs || []).forEach((c) => { clubMap[c.id] = c; });

  // Group events by club
  const eventsByClub = {};
  (content.events || []).forEach((e) => {
    if (!eventsByClub[e.club_id]) eventsByClub[e.club_id] = [];
    eventsByClub[e.club_id].push(e);
  });

  // Filter active promos
  const now = new Date().toISOString().slice(0, 10);
  const activePromos = (content.promos || []).filter(
    (p) => p.start && p.end && now >= p.start && now <= p.end,
  );

  // Clubs without events
  const clubsWithoutEvents = (content.clubs || []).filter((c) => !eventsByClub[c.id]);

  return {
    activePromos,
    clubMap,
    eventsByClub,
    clubsWithoutEvents,
    productPricing,
  };
}
